import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import classNames from 'classnames/bind';
import YodaTooltip from '../YodaTooltip/YodaTooltip';
import * as styles from './IconTooltip.css';

const cx = classNames.bind(styles);

const IconTooltip = ({
    theme,
    message,
    direction,
    tooltipPlacement,
    tooltipBodyClassName,
    tooltipContentClass,
    tooltipTextClass,
    triggerEventName,
    iconClass,
    isNotSlider,
    tooltipResContentClass,
    iconComponent,
    alignAuto,
    isRetailfeeTooltip,
    iconDetails,
    isCheckoutRetailFee,
}) => (
    <YodaTooltip
        theme={theme}
        renderTooltipContents={message}
        direction={direction}
        tooltipPlacement={tooltipPlacement}
        tooltipBodyClassName={tooltipBodyClassName}
        tooltipTextClass={tooltipTextClass}
        tooltipContentClass={isNotSlider ? tooltipResContentClass : tooltipContentClass}
        triggerEventName={triggerEventName}
        isRetailfeeTooltip={isRetailfeeTooltip}
        isCheckoutRetailFee={isCheckoutRetailFee}
        isNotSlider
        alignAuto={alignAuto}
    >
        <Icon
            iconType="svg"
            width={iconDetails.iconWidth}
            height={iconDetails.iconHeight}
            viewBox={iconDetails.iconViewBox}
            className={`${cx(styles.svgIcon, iconClass)} ${dt([
                'pointer-events-none',
                'align-text-top',
            ])}`}
        >
            {iconComponent}
        </Icon>
    </YodaTooltip>
);

IconTooltip.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    tooltipContentClass: PropTypes.string,
    tooltipTextClass: PropTypes.string,
    tooltipResContentClass: PropTypes.string,
    direction: PropTypes.string,
    tooltipPlacement: PropTypes.string,
    triggerEventName: PropTypes.string,
    iconClass: PropTypes.string,
    isNotSlider: PropTypes.bool,
    tooltipBodyClassName: PropTypes.string,
    theme: PropTypes.string,
    iconComponent: PropTypes.node,
    alignAuto: PropTypes.bool,
    isRetailfeeTooltip: PropTypes.bool,
    isCheckoutRetailFee: PropTypes.bool,
    iconDetails: PropTypes.object,
};

IconTooltip.defaultProps = {
    isNotSlider: false,
    direction: 'Topleft',
    tooltipContentClass: `${dt([
        'p-3',
        'leading-5',
        'rounded',
        'bg-gray-70',
        'border-gray-70',
        'sm:ml-10',
        'sm:w-[319px]',
        'shadow-elevation1',
        '!text-sm',
        'sm:!text-white',
        'after:!border-solid',
        'after:!border-[10px]',
        'after:!border-l-transparent',
        'after:!border-r-transparent',
        'after:!border-t-gray-70',
        'after:!border-b-transparent',
    ])} ${cx('iconTooltip', 'accountIconToolTip')}`,
    tooltipResContentClass: `${styles.iconToolTipRes} ${dt([
        'sm:ml-10',
        'sm:w-[319px]',
        'shadow-elevation1',
        '!text-sm',
        'sm:!text-white',
        'after:!border-solid',
        'after:!border-[10px]',
        'after:!border-l-transparent',
        'after:!border-r-transparent',
        'after:!border-t-gray-70',
        'after:!border-b-transparent',
        'smOnly:ml-[-226px]',
        'mdOnly:ml-[-160px]',
        'mdOnly:after:ml-40',
        'smOnly:after:ml-[226px]',
    ])}`,
    tooltipPlacement: 'Right',
    triggerEventName: 'mouseover',
    iconClass: 'icon',
    tooltipBodyClassName: '',
    tooltipTextClass: '',
    theme: '',
    iconComponent: null,
    alignAuto: false,
    isRetailfeeTooltip: false,
    isCheckoutRetailFee: false,
    iconDetails: {
        iconWidth: '24px',
        iconHeight: '24px',
        iconViewBox: '0 0 24 24',
    },
};
export default IconTooltip;
